import React from 'react';
import PropTypes from 'prop-types';

import useWindowDimensions from '../../../../../hooks/window-dimensions';
import { InventoryProductPropType } from '../../../ctrl_proptype';
import { List, Image } from '../inventory.styled';
import SelectionArea from './selection-area';
import OutOfStock from './out_of_stock';
import CheckBox from './checkbox';

const ListProduct = ({
  productHasSingleOrNoOptions,
  isMobileBuilderPreview,
  isSingleOptionProduct,
  handleOptionsChange,
  ctrlValidationError,
  isEditingResponse,
  incrementQuantity,
  decrementQuantity,
  openOptionsModal,
  handleQuantity,
  getOptionValue,
  selectProduct,
  errorMessage,
  isOutOfStock,
  inCustomise,
  inBuilder,
  formWidth,
  quantity,
  options,
  product,
  inForm,
  image,
  price,
}) => {
  const { width } = useWindowDimensions();
  
  const isSmFormAndXlDown = formWidth >= 40 && width < 1390;
  const isMdFormAndLgDown = formWidth <= 65 && width < 992;
  const isLgFormAndLgDown = formWidth > 65 && width < 935;

  const showMiniSelectors = isMobileBuilderPreview || (!inBuilder && formWidth < 40) || (inCustomise && formWidth < 65) || (
    width <= 768 || isMdFormAndLgDown || isLgFormAndLgDown || isSmFormAndXlDown
  );

  const mimicViewPort = (mainClass) => {
    if (formWidth > 40 && formWidth <= 50) return `${mainClass} sm`;
    if (formWidth <= 40) return `${mainClass} xs`;
    return mainClass;
  };

  const classes = {
    container: showMiniSelectors ? 'container sm' : 'container',
    content: showMiniSelectors ? 'content sm' : 'content',
    detail: mimicViewPort('detail'),
    image: mimicViewPort('image'),
  };

  return (
    <List>
      <CheckBox
        disabled={!inForm || isOutOfStock || isEditingResponse}
        updateProduct={selectProduct}
        value={!!quantity}
        prop="quantity"
        isList
      />

      <div className={classes.content}>
        <div className={classes.container}>
          <div className={classes.image}>
            <Image src={image} alt="product_img" />
          </div>

          <div className={classes.detail}>
            <div className="title" title={product.product_title}>
              <span>{product.product_title}</span>
            </div>

            {product.description && (
              <div className="description">
                <p title={product.description}>{product.description}</p>
              </div>
            )}

            {!showMiniSelectors && (
              <>
                {(errorMessage || ctrlValidationError) && (
                  <OutOfStock ctrlValidationError={ctrlValidationError || errorMessage} />
                )}
                
                <SelectionArea
                  productHasSingleOrNoOptions={productHasSingleOrNoOptions}
                  isSingleOptionProduct={isSingleOptionProduct}
                  handleOptionsChange={handleOptionsChange}
                  decrementQuantity={decrementQuantity}
                  incrementQuantity={incrementQuantity}
                  isEditingResponse={isEditingResponse}
                  openOptionsModal={openOptionsModal}
                  handleQuantity={handleQuantity}
                  getOptionValue={getOptionValue}
                  isOutOfStock={isOutOfStock}
                  quantity={quantity}
                  options={options}
                  inForm={inForm}
                  price={price}
                  isList
                />
              </>
            )}
          </div>
        </div>

        {showMiniSelectors && (
          <>
            {(errorMessage || ctrlValidationError) && (
              <div className="error mobile">
                <OutOfStock ctrlValidationError={ctrlValidationError || errorMessage} />
              </div>
            )}

            <SelectionArea
              productHasSingleOrNoOptions={productHasSingleOrNoOptions}
              isSingleOptionProduct={isSingleOptionProduct}
              handleOptionsChange={handleOptionsChange}
              decrementQuantity={decrementQuantity}
              incrementQuantity={incrementQuantity}
              isEditingResponse={isEditingResponse}
              openOptionsModal={openOptionsModal}
              handleQuantity={handleQuantity}
              getOptionValue={getOptionValue}
              isOutOfStock={isOutOfStock}
              quantity={quantity}
              hideSelectorLabels
              options={options}
              inForm={inForm}
              price={price}
              isList
            />
          </>
        )}
      </div>
    </List>
  );
};

ListProduct.propTypes = {
  formWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  product: PropTypes.shape(InventoryProductPropType).isRequired,
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  productHasSingleOrNoOptions: PropTypes.bool.isRequired,
  isMobileBuilderPreview: PropTypes.bool.isRequired,
  isSingleOptionProduct: PropTypes.bool.isRequired,
  handleOptionsChange: PropTypes.func.isRequired,
  isEditingResponse: PropTypes.bool.isRequired,
  incrementQuantity: PropTypes.func.isRequired,
  decrementQuantity: PropTypes.func.isRequired,
  openOptionsModal: PropTypes.func.isRequired,
  handleQuantity: PropTypes.func.isRequired,
  getOptionValue: PropTypes.func.isRequired,
  errorMessage: PropTypes.string.isRequired,
  selectProduct: PropTypes.func.isRequired,
  inCustomise: PropTypes.bool.isRequired,
  quantity: PropTypes.number.isRequired,
  ctrlValidationError: PropTypes.string,
  inBuilder: PropTypes.bool.isRequired,
  image: PropTypes.string.isRequired,
  price: PropTypes.string.isRequired,
  inForm: PropTypes.bool.isRequired,
};

ListProduct.defaultProps = {
  ctrlValidationError: null,
};

export default ListProduct;
